import styled from '@emotion/styled';
import {
  createContext,
  createElement,
  Dispatch,
  FC,
  SetStateAction,
  Suspense,
  useContext,
  useEffect,
  useState,
} from 'react';
import { Redirect, Route, Switch } from 'react-router';

import { QueryCacheType } from '../../entity/QueryCache';
import AdAnalyticsPage from '../connected/AdAnalyticsDetailPage';
import AdAnalyticsListPage from '../connected/AdAnalyticsListPage';
import AdAnalyticsReportListPage from '../connected/AdAnalyticsReportListPage';
import AdAnalyticsReportPage from '../connected/AdAnalyticsReportPage';
import ConnectedAdShowcasePage from '../connected/AdSearchPage';
import ConfigurationPage from '../connected/ConfigurationPage';
import CreationDetailPage from '../connected/CreationDetailPage';
import DesignInspirationsListPage from '../connected/DesignInspirationsListPage';
import DirectionTypesPage from '../connected/DirectionTypesPage';
import ProjectDetailPage from '../connected/ProjectDetailPage';
import ProjectDiffPage from '../connected/ProjectDiffPage';
import ProjectsListPage from '../connected/ProjectsListPage';
import ProjectTypesListPage from '../connected/ProjectTypesListPage';
import { context as HistoryContext } from '../context/history';
import { context as StateContext } from '../context/state';
import { AdSearchDetail } from '../page/AdSearchPage/AdSearchDetail';
import HomePage from '../page/HomePage';
import InsightCategoryPage from '../page/InsightCategoryPage';
import ProjectEditingPage from '../page/ProjectEditingPage';

type Props = {
  className?: string;
};

const initialState: QueryCacheType = {
  query: null,
  duration: null,
  aspectRatio: null,
  industry: null,
  placement: null,
  offset: 0,
  organizationTag: [],
  isFavFilter: false,
};

export const SearchQueryContext = createContext<{
  state: QueryCacheType;
  dispatch: Dispatch<SetStateAction<QueryCacheType>>;
}>({
  state: initialState,
  dispatch: () => null,
});

const SignedInScreen: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const history = useContext(HistoryContext);
  const [searchQueryCache, setSearchQueryCache] = useState(initialState);

  useEffect(
    () =>
      history.listen(() => {
        if (typeof window.kzs === 'function') window.kzs('locationUpdated');
      }),
    [history],
  );

  return (
    <SearchQueryContext.Provider value={{ state: searchQueryCache, dispatch: setSearchQueryCache }}>
      <Root className={className}>
        <Suspense fallback={<div />}>
          <Switch>
            <Route exact sensitive path="/projects" component={ProjectsListPage} />
            <Route exact sensitive path="/direction_types" component={DirectionTypesPage} />
            {/* <Route exact sensitive path="/design_inspirations" component={DesignInspirationsListPage} /> */}
            <Route exact sensitive path="/project_types" component={ProjectTypesListPage} />
            <Route exact sensitive path="/projects/:projectId/diff/" component={ProjectDiffPage} />
            <Route exact sensitive path="/projects/:projectId/edit" component={ProjectEditingPage} />
            <Route exact sensitive path="/projects/:projectId/:tabName" component={ProjectDetailPage} />
            <Route exact sensitive path="/creations/:creationId" component={CreationDetailPage} />
            <Route exact sensitive path="/settings" component={ConfigurationPage} />
            <Route exact sensitive path="/analytics" component={AdAnalyticsPage} />
            <Route exact sensitive path="/ad-creatives" component={AdAnalyticsListPage} />
            <Route exact sensitive path="/analytics-report" component={AdAnalyticsReportPage} />
            <Route exact sensitive path="/ad-creatives-report" component={AdAnalyticsReportListPage} />
            <Route exact sensitive path="/search" component={ConnectedAdShowcasePage} />
            <Route exact sensitive path="/search/:creativeId" component={AdSearchDetail} />
            <Route exact sensitive path="/latest-insights" component={HomePage} />
            <Route exact sensitive path="/insight-categories/:categoryId" component={InsightCategoryPage} />
            <Redirect from="/" to="/latest-insights" />
          </Switch>
        </Suspense>
        <DesignInspirationsListPage visible={state.isOpenDesignInspirationScreen} />
      </Root>
    </SearchQueryContext.Provider>
  );
};

const Root = styled('div')({});

export default SignedInScreen;
